// LM Audit d'acquisition — paragraphe 2.6 « Honoraires ». Calcul unique
// partagé par le formulaire (affichage) et la génération du document.
//   - fixe          : total HT = montant saisi (montant_fixe)
//   - proportionnel : total HT = prix d'achat × taux (montant minimum
//                     seulement mentionné dans la lettre, sans plancher calculé)

export const nombre = (v) => {
  const n = parseFloat(String(v ?? "").replace(/[\s  €%]/g, "").replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

// "150 000,00" — sans « € » : le modèle Word l'ajoute lui-même.
export const montant = (n) =>
  n === null || n === undefined
    ? ""
    : n
        .toFixed(2)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

// Taux affiché tel que saisi, sans zéros inutiles ("2", "1,5").
export const taux = (v) => {
  const n = nombre(v);
  return n === null ? "" : String(Math.round(n * 10000) / 10000).replace(".", ",");
};

export function calculHonorairesAudit(formData) {
  const proportionnel = formData.type_remuneration === "proportionnel";
  const ht = proportionnel
    ? nombre(formData.prix_achat) !== null && nombre(formData.taux_honoraires) !== null
      ? (nombre(formData.prix_achat) * nombre(formData.taux_honoraires)) / 100
      : null
    : nombre(formData.montant_fixe);
  const tauxTva = nombre(formData.TVA_honoraires_pourcentage) ?? 0;
  const tva = ht === null ? null : (ht * tauxTva) / 100;
  return {
    proportionnel,
    ht,
    tva,
    ttc: ht === null ? null : ht + tva,
  };
}
